var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.showEditTemplate
    ? _c(
        "div",
        { staticClass: "email-template-customer-portal-tab-container" },
        [
          _c("LfHeaderTitle", {
            staticClass: "header-title",
            attrs: { title: _vm.headerTitle },
          }),
          Object.keys(_vm.listConfiguration).length
            ? _c("GridTable", {
                attrs: {
                  itemsData: _vm.listItems,
                  gridConfiguration: _vm.listConfiguration["Config"],
                  title: _vm.$t("navigation.drawer-menu-items.email_templates"),
                  toolbarOptions: _vm.toolbarOptionsCustom,
                  contextMenuItems: _vm.contextMenu,
                  listName: _vm.listConfiguration["Alias"],
                  context: _vm.context,
                  showHeader: false,
                  isInTab: "",
                  showColumnChooser: false,
                },
                on: {
                  contextMenuClicked: _vm.onContextMenuClicked,
                  cellClicked: _vm.onCellClicked,
                },
              })
            : _c("SpinnerLayerComponent", { staticClass: "spinner-layer" }),
        ],
        1
      )
    : _c("EditTemplateComponent", {
        attrs: { template: _vm.selectedTemplate },
        on: { "on-close-form": _vm.showGrid },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }